import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2010,
          month: 11,
          day: 7,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 2,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 5,
          day: 13,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 11,
          day: 19,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 22,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2010,
          month: 11,
          day: 7,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 2,
          day: 10,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 5,
          day: 13,
        },
      },
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 11,
          day: 19,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 8,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 2,
          day: 22,
        },
      },
    ],
  },
};
